
import { Movie, PendingAction } from "@/types/movie";

// Import the refactored action functions from the submodules
import { 
  toggleMovieFavorite as toggleFavoriteAction, 
  toggleMoviePlanToWatch as togglePlanToWatchAction,
  deleteMovie as deleteMovieAction,
  undoAction as undoActionHandler,
  createPendingAction,
  ActionHandlers
} from './actions';

/**
 * Toggles a movie's favorite status using universal metadata architecture
 * UPDATED: Now uses universal complete movie object in onComplete signature
 */
export const toggleMovieFavorite = async (
  movie: Movie,
  currentSection: string | undefined,
  pendingActions: PendingAction[],
  addPendingAction: (action: PendingAction) => void,
  removePendingAction: (actionId: string) => void,
  updateMovieState: (tmdbId: number, props: Partial<Movie>) => void
): Promise<void> => {
  const handlers: ActionHandlers = {
    onComplete: (tmdbId, _, newValue, enrichedMovie) => {
      // UPDATED: Use enriched movie from universal service for complete state update
      updateMovieState(tmdbId, enrichedMovie);
    },
    updateMovieState,
    addPendingAction,
    removePendingAction
  };
  
  return toggleFavoriteAction(movie, currentSection, pendingActions, handlers);
};

/**
 * Toggles a movie's plan to watch status using universal metadata architecture
 * UPDATED: Now uses universal complete movie object in onComplete signature
 */
export const toggleMoviePlanToWatch = async (
  movie: Movie,
  currentSection: string | undefined,
  pendingActions: PendingAction[],
  addPendingAction: (action: PendingAction) => void,
  removePendingAction: (actionId: string) => void,
  updateMovieState: (tmdbId: number, props: Partial<Movie>) => void
): Promise<void> => {
  const handlers: ActionHandlers = {
    onComplete: (tmdbId, _, newValue, enrichedMovie) => {
      // UPDATED: Use enriched movie from universal service for complete state update
      updateMovieState(tmdbId, enrichedMovie);
    },
    updateMovieState,
    addPendingAction,
    removePendingAction
  };
  
  return togglePlanToWatchAction(movie, currentSection, pendingActions, handlers);
};

/**
 * Deletes a movie using universal system
 */
export const deleteMovie = async (
  tmdbId: number,
  pendingActions: PendingAction[],
  removePendingAction: (actionId: string) => void,
  removeMovieFromState: (tmdbId: number) => void
): Promise<void> => {
  return deleteMovieAction(tmdbId, pendingActions, removePendingAction, removeMovieFromState);
};

/**
 * Undoes a pending action using universal system
 */
export const undoAction = (
  actionId: string,
  pendingActions: PendingAction[],
  removePendingAction: (actionId: string) => void
): void => {
  return undoActionHandler(actionId, pendingActions, removePendingAction);
};

// Export the createPendingAction utility function as well
export { createPendingAction };
